import { render, staticRenderFns } from "./FacebookAds.vue?vue&type=template&id=53087fc9&scoped=true&"
import script from "./FacebookAds.vue?vue&type=script&lang=js&"
export * from "./FacebookAds.vue?vue&type=script&lang=js&"
import style0 from "./FacebookAds.vue?vue&type=style&index=0&id=53087fc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53087fc9",
  null
  
)

export default component.exports